// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d622c88a","239":"c1fb8499","455":"0b5cbe2d"}[chunkId] + ".chunk.js";
};